import store from '../features/metamask/metamask';

export default ({ app }) => {
  if (
    typeof window !== 'undefined' &&
    window.__CARBON_V2_LOCAL_HARNESS__ === true
  ) {
    window.__BRAZIL_CARBON_STORE__ = store;
  }
  app.use(store);
};

export { store };
